import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {UserFunctionCode} from '../../constants/UserFunctionCode';
import {ScheduledTaskStatus} from '../../models/ScheduledTaskStatus';
import {SchedulerStatusService} from '../../services/scheduler-status.service';
import {SecurityService} from '../../services/security.service';

@Component({
  selector: 'app-scheduler-status',
  templateUrl: './scheduler-status.component.html',
  styleUrls: ['./scheduler-status.component.scss']
})
export class SchedulerStatusComponent implements OnInit {

  canViewSchedulerStatus: boolean = false;
  isLoading: boolean = true;
  selector: string;

  tasks: ScheduledTaskStatus[] = [];
  displayedColumns: string[] = ['name', 'description', 'frequency', 'lastExecutionTime'];
  dataSource: MatTableDataSource<ScheduledTaskStatus> = new MatTableDataSource<ScheduledTaskStatus>();
  pageSizes = [10, 15, 20, 25];

  constructor(
    private readonly schedulerStatusService: SchedulerStatusService,
    private readonly securityService: SecurityService,
    private elementRef: ElementRef
  ) { }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.canViewSchedulerStatus = this.securityService.can(UserFunctionCode.MAINTENANCE);
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
    if (this.canViewSchedulerStatus) {
      this.fetchData();
    }
  }

  fetchData() {
    this.schedulerStatusService.getAllTaskStatus().subscribe(
      res => {
        this.tasks = res;
        this.dataSource.data = this.tasks;
        this.isLoading = false;
      }
    );
  }

}
